import { Button, Dialog, Typography } from '@mui/material';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import Flex from '@Components/Bases/Flex';

type ConfirmModalProps = {
  topic: string;
  description: string;
  opened: boolean;
  loading?: boolean;
  close: () => void;
  confirm: () => void;
  disableBackdropClose?: boolean;
};

const ConfirmModal = ({
  topic,
  description,
  opened,
  loading,
  close,
  confirm,
  disableBackdropClose = false,
}: ConfirmModalProps) => {
  return (
    <Dialog
      open={opened}
      onClose={(_, reason) => {
        if (!disableBackdropClose || reason !== 'backdropClick') close();
      }}
      maxWidth="xs"
    >
      <Flex p={2} gap={2} borderBottom="1px solid rgba(0, 0, 0, 0.12)">
        <AssignmentLateOutlinedIcon
          style={{ fontSize: 32 }}
          color={'primary'}
        />
        <Flex flexDirection={'column'} gap={1}>
          <Typography fontWeight={'bold'} fontSize={16}>
            {topic}
          </Typography>
          <Typography>{description}</Typography>
        </Flex>
      </Flex>
      <Flex gap={2} p={1} justifyContent="flex-end">
        <Button
          variant="contained"
          color="inherit"
          onClick={close}
          disabled={loading}
        >
          ยกเลิก
        </Button>
        <Button onClick={confirm} loading={loading} loadingPosition="end">
          {loading ? 'กรุณารอสักครู่' : 'ยืนยัน'}
        </Button>
      </Flex>
    </Dialog>
  );
};

export default ConfirmModal;
